<script>
    import AuthService from "../services/auth.service";
    import AlteryxService from "../services/alteryx.service";

    export let user = null;

    let alteryxAllowed = false;
    userAllowed();
    // Verify if user has permission to see this section
    async function userAllowed() {
        try {
            const response = await AlteryxService.isAllowed();
            if (response && response.data.ok) {
                alteryxAllowed = response.data.ok;
            }
        } catch (e) {
            console.log(e);
            errorMessage = e.message;
        }
    }
</script>

<nav class="navbar navbar-expand-lg navbar-dark bg-dark bg-riverside">
    <a class="navbar-brand" href="/dashboard">
        <img src="/img/riverside-logo.svg" height="20" class="img-riverside" alt="Riverside" />
        KEY PERFORMANCE INDICATORS
    </a>
    <div class="right-items">
        <a id="landing-page-url" href="https://salesexcellence.seagage.com" target="_blank"
            ><i class="fa fa-th" aria-hidden="true" /> Riverside Ecosystem</a
        >
        <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarMenu"
            aria-controls="navbarMenu"
            aria-expanded="false"
            aria-label="Toggle navigation"
        >
            <span class="navbar-toggler-icon" />
        </button>
        <div class="collapse navbar-collapse" id="navbarMenu">
            <ul class="navbar-nav ml-auto">
                {#if user}
                    <li class="nav-item dropdown">
                        <a
                            class="nav-link dropdown-toggle"
                            href="#"
                            id="navbarDropdown"
                            role="button"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            {user.name}
                        </a>
                        <div
                            class="dropdown-menu dropdown-menu-right"
                            aria-labelledby="navbarDropdown"
                        >
                            {#if AuthService.can("SET_HR_PERMISSIONS") || AuthService.canShow('talent_tracking')}
                                <a class="dropdown-item" href="/permissions"
                                    >Permissions</a
                                >
                            {/if}
                            {#if AuthService.can("RESTORE_SECTION") || AuthService.can("RESTORE_TEAM")}
                                <a class="dropdown-item" href="/trashbin"
                                    >Trash Bin</a
                                >
                            {/if}
                            {#if alteryxAllowed}
                                <a class="dropdown-item" href="/alteryx"
                                    >Alteryx</a
                                >
                            {/if}
                            {#if AuthService.canShow('api_settings')}
                                <a class="dropdown-item" href="/api-settings"
                                    >API Settings</a
                                >
                            {/if}
                            {#if AuthService.canShow('talent_tracking')}
                                <a class="dropdown-item" href="/talent-tracking"
                                    >Talent Tracking</a
                                >
                            {/if}
                            <a class="dropdown-item" target="_blank" href="https://support.seagage.com/support/home">Help</a>
                            <div class="dropdown-divider" />
                            <a class="dropdown-item" href="/logout">Logout</a>
                        </div>
                    </li>
                {:else}
                    <li class="nav-item">
                        <a class="nav-link" target="_blank" href="https://support.seagage.com/support/home">Help</a>
                    </li>
                {/if}
            </ul>
        </div>
    </div>
</nav>

<style>
    .right-items {
        width: 100%;
        text-align: right;
    }

    #landing-page-url {
        color: #fff;
    }

    #navbarMenu {
        display: inline-block !important;
    }
</style>